exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gz-error-bar .error-bar{background-color:#ff5722}gz-error-bar .msg-container{margin:6px 0;-ms-flex:1 1 auto}gz-error-bar md-toolbar{min-height:44px;padding:0 16px}gz-error-bar .error-msg{font-size:16px;margin-right:16px}gz-error-bar .error-details{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/error-bar/error-bar.scss
// module id = 106
// module chunks = 0